import React, {Fragment, useState} from "react";
import SnackbarUtil from '@/utils/SnackbarUtil';
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, Box} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import Circle from '@mui/icons-material/Circle';
import UserService from '@/services/auth/UserService'
import {ReactComponent as ResetPasswordIcon} from "@/assets/person/resetpassword.svg";

const resetPasswordStyle = {
  '& .MuiPaper-root': {width: '500px', top: '-10vh'},
  '.MuiDialog-paper': {maxWidth: '60vw'},
};

export interface EmailProps {
  employees: any
}

const ResetEmpPassword = (props: EmailProps) => {
  const [info, setInfo] = useState<boolean>(false)
  const {t} = useTranslation()
  const [loading, setLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [employeeCount, setEmployeeCount] = React.useState<number>(0);
  const toggleDrawer =
    (open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (props.employees.length == 0) {
          SnackbarUtil.error(t("common.Select employee first."),
            {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
          return;
        }
        setEmployeeCount(props.employees.length);
        setVisible(open);
        setInfo(true);
        const employeesWithoutEmail = props.employees.filter((emp: any) => !emp.email).length;
        setEmployeeCount(prev => prev - employeesWithoutEmail);
      };
  const resetEmpPassword = () => {
    UserService.resetPasswordV2({"emp_list": props.employees}).then(
      (result) => {
        if (result.code == 'UASE0006') {
          SnackbarUtil.error(t("common.There has invalid format in email data."),
            {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
          return
        }
        SnackbarUtil.success(t("common.reset employees password successful.", {employee_count: employeeCount}),
          {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
      }
    )
    setInfo(false)
  }

  return (
    <Fragment>
      <Grid item={true} onClick={toggleDrawer(true)}>
        <Grid sx={{display: "flex"}}>
          <Grid sx={{marginLeft: "0px"}}>{<ResetPasswordIcon/>}</Grid>
          <Grid sx={{
            color: "rgb(117, 130, 138)",
            fontSize: "14px !important",
            textTransform: 'none !important',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif !important',
            fontWeight: 'normal',
            lineHeight: 1.5,
            marginLeft: "4px",
          }}>{t("common.Reset Password")}</Grid>
        </Grid>
      </Grid>
      <Dialog
        open={info}
        onClose={() => {
          setInfo(false);
        }}
        sx={resetPasswordStyle}
      >
        <DialogTitle>
          {t("common.Reset Employee Password")}
        </DialogTitle>
        <DialogContent sx={{lineHeight: '25px', color: 'gray', mt: 2}}>
          <Typography variant="body1" sx={{color: "#000"}}>
            {t('common.reset employee password info', {employee_count: employeeCount})}
          </Typography>
          <Box sx={{mt: 2, backgroundColor: '#f5f5f5', p: 2, borderRadius: 2}}>
            {props.employees.map((emp: any, logIndex: number) => (
              emp.email ? (
                <Grid key={logIndex} sx={{display: "flex", alignItems: "center", mb: 1}}>
                  <Grid>
                    <Circle sx={{color: "#2BA9DE", mr: 1, fontSize: 8}}/>
                  </Grid>
                  <Grid sx={{color: "#000"}}>
                    {emp.email}
                  </Grid>
                </Grid>
              ) : <></>
            ))}
          </Box>
          <DialogActions>
            <LoadingButton
              id='ConfirmButton'
              loading={loading}
              sx={{textTransform: "capitalize"}}
              onClick={() => (resetEmpPassword())}
              variant={"contained"}>{t('common.confirm')}</LoadingButton>
            <Button id='CancelButton' sx={{textTransform: "capitalize"}} onClick={() => {
              setInfo(false);
            }}>{t('common.cancel')}</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}

export default ResetEmpPassword;
